import isString from 'lodash/isString'
import { parseIntNoNaN } from '@purecarslabs/signal-utils/parseIntFloat'
import { NativeLeadType } from '@app-src/data/leads/types'
import { PriceDropPayloadType } from './types'

/**
 * cookLeadForPriceDrops
 * @description converts the data manipulated by the form application to the native price drop subscription type for POSTing to backend
 * @param {Object} lead - the native lead submitted to the BE
 * @return {Object} - the PriceDropPayloadType object generated from the above inputs
 */
export function cookLeadForPriceDrops(
  lead: NativeLeadType
): PriceDropPayloadType {
  return {
    accountId: lead.context.accountId ?? '',
    firstName: lead.contact.firstName ?? '',
    lastName: lead.contact.lastName ?? '',
    email: lead.contact.email,
    phone: lead.contact.phone,
    contactChannel: isString(lead.contact.preferredMethodOfContact)
      ? parseIntNoNaN(lead.contact.preferredMethodOfContact as string)
      : lead.contact.preferredMethodOfContact ?? 0,
    vin: lead.context.vin ?? ''
  }
}
